// src/components/MainPage.js
import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CsrfTokenContext } from '../CsrfTokenContext';
import { setBlinking, setSpinStrategies, setChecked } from './slices/simulationCommonSlicer';
import { setSelectedSymbol, setInterval, setStartDate, setEndDate, setDateRangeChanged } from './slices/simulationEntriesSlicer';
import { setPlotError, setPlotSignal, setPlotStrategies, setSignalsData } from './slices/simulationPlotSlicer';
import { setStrategiesData, setStrategyTableRow, setSelectedRowIndex, setSelectedStrategy } from './slices/simulationStratgySlicer';
import { setPreviousWalletId, setBlinkWallet } from './slices/globalDataSlicer';
import Switch from 'react-switch';
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';

import styles from './Simulator.module.css';
import CustomSelect from '../components/CustomSelect'; 
import DataPicker from '../components/DataPicker'; 
import TextBaloon from '../components/TextBaloon'; 
import HalfDonutChart from '../components/Donut_Indicator';
import Spinner from '../components/Spinner';
import ChartBar from '../components/ChartBar';
import ChartSignals from '../components/ChartSignals';
import BecomePremiumInvite from '../components/BecomePremiumInvite';
import LimitedAdvise from '../components/LimitedAdvise';
import DecisionModal from '../components/DecisionModal';
import Tooltip from '../components/Tooltip';
import PieChartBuySellStrategies from '../components/PieChartBuySellStrategies';


function Simulator(){ 

    const [followMesssage, setFollowMesssage] = useState({color:'', message:''});    
    const [strategyError, setStrategyError] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [spin, setSpin] = useState(false);
    const [actionStatus, setActionStatus] = useState(false);
    const [showInvite, setShowInvite] = useState(false);
    const [snapshotPrice, setSnapshotPrice] = useState(0.0);
   
    const handleShow = () => {        
        if(isPremium){
            if(email===''){
                setFollowMesssage({color:'orangered', message:'It looks like you haven’t added your email yet. Please register it on the ‘My Space’ page before proceeding with this action.'});
                handleClose();
                return;
            }

            setShowInvite(false);
            setModalShow(true);            
        }
        else{
            setShowInvite(true);
        }
    };
    const handleClose = () => setModalShow(false);

    const csrfToken = useContext(CsrfTokenContext);    
    
    const entriesRef = useRef(null);
    const tableContainerRef = useRef(null);
    const plotStrategiesRef = useRef(null);
    const selectedPlotStrategyRef = useRef(null);
    const plotErrorContainerRef = useRef(null);  
    const tableRefs = useRef([]);    
   
    const dispatch = useDispatch();
    const { blinking, spinStrategies, checked } = useSelector(state => state.simulationCommon);
    const { selectedSymbol, interval, startDate, endDate, dateRangeChanged } = useSelector(state => state.simulationEntries);    
    const { plotError, plotSignal, plotStrategies, signalsData } = useSelector(state => state.simulationPlot);
    const { strategiesData, strategyTableRow, selectedRowIndex, selectedStrategyPlot, selectedStrategy } = useSelector(state => state.simulationStratgy);    
    const { walletId, isPremium, previousWalletId, email } = useSelector(state => state.globalData);
    const { prices } = useSelector(state => state.streamCryptoInfo);
    
    // *********** HANDLES ***********
    const handleIntervalChange = (event) => {
        dispatch(setInterval(event)); 
        hookParts(entriesRef);        
        // dispatch(setInterval(event.target.value)); 
        if(interval && Object.keys(selectedSymbol).length !== 0 && startDate !== '' && endDate !== ''){            
            dispatch(setBlinking(true));            
        }
        dispatch(setPlotStrategies([]));
        dispatch(setStrategiesData([]));
        dispatch(setPlotSignal({}));
        dispatch(setSignalsData(null));
        dispatch(setStrategyTableRow(null));
        dispatch(setSelectedRowIndex(null));
        dispatch(setPlotError(null));
        setStrategyError(null);
      };

    const handleChange = (selectedOption) => {       
        const symbolSel = {'value':selectedOption.value, 'symbol_icon': selectedOption.symbol_icon, 'ranking':selectedOption.ranking}        
        dispatch(setSelectedSymbol(symbolSel));        
        if(interval && Object.keys(selectedSymbol).length !== 0  && startDate !== '' && endDate !== ''){            
            dispatch(setBlinking(true));            
        }
        dispatch(setPlotStrategies([]));        
        dispatch(setStrategiesData([]));
        dispatch(setPlotSignal({}));
        dispatch(setSignalsData(null));
        dispatch(setStrategyTableRow(null));
        dispatch(setSelectedRowIndex(null));
        dispatch(setPlotError(null));
        setStrategyError(null);
        dispatch(setDateRangeChanged(true));
    };

    const handleTableRowClick = (item, index) => {
        setFollowMesssage({color:'', message:''});
        dispatch(setSelectedRowIndex(index));
        dispatch(setStrategyTableRow(item));
        dispatch(setSignalsData(null));
        dispatch(setPlotError(null));
        handlePlot(item);
    };

    const handleStartDateChange = (date) => {          
        dispatch(setStartDate(date.toDateString()));        
        if(interval && Object.keys(selectedSymbol).length !== 0 && endDate){            
            dispatch(setBlinking(true));            
        }
       
        if(endDate!=='' && isStartDateGreater(startDate, endDate)){
            dispatch(setEndDate(''));
        }

        dispatch(setPlotError(null));
        dispatch(setSelectedRowIndex(null));
        dispatch(setDateRangeChanged(true));
        dispatch(setPlotStrategies([]));        
        dispatch(setStrategiesData([]));
        dispatch(setPlotSignal({}));
        dispatch(setSignalsData(null));
      };

    const handleEndDateChange = (date) => {        
        dispatch(setEndDate(date.toDateString()));        
        if(interval && Object.keys(selectedSymbol).length !== 0 && startDate !== ''){            
            dispatch(setBlinking(true));            
        }
        dispatch(setSelectedRowIndex(null));
        dispatch(setDateRangeChanged(true));
        dispatch(setPlotStrategies([]));        
        dispatch(setStrategiesData([]));
        dispatch(setPlotSignal({}));
        dispatch(setSignalsData(null));
      };
        
    const handlePlot = (item) => {        
        // dispatch(setSelectedStrategy(item.strategy));
        dispatch(setSelectedStrategy({'symbol' : item.symbol, 'interval' : item.interval, 'ema_1':item.ema_1, 'ema_2' : item.ema_2, 'strategy' : item.strategy}));
        plotSignalData(item.symbol, item.interval, item.ema_1, item.ema_2, item.strategy);        
    };

    const handlePlotStrategies = (selectValue, inter, startDate, endDate, dChanged) => { 
        dispatch(setSelectedRowIndex(null));       
        setStrategyError(null);
        setFollowMesssage({color:'', message:''});
        if(selectValue && inter && startDate !== '' && endDate !== ''){
            plot_Strategies(selectValue.value, inter, startDate, endDate, dChanged);        
        }
        dispatch(setBlinking(false));
    };

    const handlePlotError = (pltError) => {                
        if(pltError){
            dispatch(setPlotError(pltError.message));
        }
        dispatch(setBlinking(false));
        hookParts(plotErrorContainerRef);
    };

    const handlePlotStrategiesError = (pltError) => {
        console.error('Error plotting data:', pltError);
        const err = pltError instanceof Error ? pltError : new Error(String(pltError));
        err.message = `Oops! Something went wrong. Try again, if the issue persists, It might be due to the selected date range, or ${selectedSymbol.value} may not have enough data to be explored.`;
        setStrategyError(err);
        dispatch(setSpinStrategies(false));        
        dispatch(setBlinking(false));
        hookParts(plotErrorContainerRef);        
    };
    
    const handleCheckChange = (nextChecked) => {
        dispatch(setChecked(nextChecked));        
        dispatch(setBlinkWallet(false)); 

        if(nextChecked && walletId===0){
            dispatch(setBlinkWallet(true));            
        }

        handleDefaultStrategies();
    };

    const handleNotify = () => {
        setFollowStrategy();
    };

    // *********** FUNCTIONS ***********
   
    const hookParts = (hookTo) => {
        setTimeout(() => {
            if (hookTo.current) {
                // window.scrollTo({
                //     top: hookTo.current.offsetTop,
                //     behavior: 'smooth'
                // });
                hookTo.current.scrollIntoView({top: hookTo.current.offsetTop, behavior: 'smooth' });
            }
        }, 300);
    };

    function isStartDateGreater(startDate, endDate) {
        // Convert text dates to Date objects
        const start = new Date(startDate);
        const end = new Date(endDate);
      
        // Compare the dates
        return start > end;
    }

    const getMinDate = (numDays) =>{
        
        // Get the current date
        const now = new Date();

        // Subtract the period (number of days)
        const pastDate = new Date(now.setDate(now.getDate() - numDays));

        // Format the date as 'YYYY-MM-DD'
        const year = pastDate.getFullYear();
        const month = String(pastDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(pastDate.getDate()).padStart(2, '0');
        
        return new Date(year, month-1, day);;
    }

    const addDays = (date, days) => {
        const result = new Date(date); // Create a new Date object based on the given date
        result.setDate(result.getDate() + days); // Add the specified number of days
        return result;
    };

    const formatDate = (date) => {
        const result = new Date(date);
        const year = result.getFullYear();
        const month = String(result.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(result.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    function getFormattedTodayDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    
    const getOperationDays = () => {
        // Calculate the time difference in milliseconds

        const sDate = new Date(startDate);
        const eDate = new Date(endDate);

        const timeDifference = Math.abs(sDate - eDate);
        // Convert time difference from milliseconds to days
        const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        return dayDifference;
    };
    

    // *********** END POINTS ***********

    const refreshTokenIfNeeded = useCallback(async () => {
        if (isTokenExpired()) {        
          await handleLogin();
        }    
      },[]);     
 
    const fetchData = async () => {
        try {
            await refreshTokenIfNeeded();
            
            const response = await fetch(`/api/strategiesList`, {
                method: 'GET',
                headers: {                    
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                }
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error);
            }
            
            const result = await response.json();
                                 
            dispatch(setStrategiesData(result));
            hookParts(tableContainerRef);    
            
        } catch (err) {
            console.error('Error fetching data:', err);
        }
    };

    const setFollowStrategy = async () => {
        try {

            await refreshTokenIfNeeded();
          
            setActionStatus(false);
            setSpin(true);
            setFollowMesssage({color:'', message:''});
                      
            await fetch(`/api/set_follow_strategy`, {
                method: 'POST',
                // credentials: 'include',
                headers: {                    
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken, // Ensure the CSRF token is correctly passed
                },
                body: JSON.stringify({strategy_set : {
                    symbol: selectedStrategy['symbol'],
                    interval: selectedStrategy['interval'],
                    ema1: selectedStrategy['ema_1'],
                    ema2: selectedStrategy['ema_2'],
                    strategy: selectedStrategy['strategy'],
                    wallet_id: walletId,
                    isDefaultStrategy: !checked,
                    following: true,
                    note:null
                }})
            });

            setActionStatus(true);
            setSpin(false);

            setTimeout(() => {
                setModalShow(false);
                setActionStatus(false);                
                setFollowMesssage({color:'#3b4dda', message:"You will receive email for each new signal for this Strategy. Manage it on 'My Space'"});
            }, 1000);
      
        } catch (err) {
          console.error('Error fetching data:', err);
          setActionStatus(false);
          setSpin(false);
        }
    };

    const fetchSignals = async () => {
        try {
            await refreshTokenIfNeeded();

            const response = await fetch(`/api/signals`, {
                method: 'GET',
                // credentials: 'include',
                headers: {                    
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                }
            });
            
            if (!response.ok) {
                // throw new Error('Network response was not ok ' + response.statusText);
                const errorData = await response.json();
                    throw new Error(errorData.error);
            }
            const result = await response.json();
            dispatch(setSignalsData(result));
        } catch (err) {
            console.error('Error fetching data:', err);
            // setError(err);
        }
    };
    
    const plotSignalData = async (symbol, interval, ema_1, ema_2, strategy) => {
        try {

            await refreshTokenIfNeeded();

            const ema1N = Number(ema_1);
            const ema2N = Number(ema_2);
            const strategyN = Number(strategy);            
            
            dispatch(setPlotError(null));            
            // document.getElementById('btnPlot').innerText = `Plotting Simulation for ${symbol}...`; 
 
            const strFetch = `/api/plotSignalData?symbol=${symbol}&interval=${interval}&ema_1=${ema1N}&ema_2=${ema2N}&strategy=${strategyN}`;
                        
            fetch(strFetch, {
                    method: 'GET',
                    // credentials: 'include',
                    headers: {                        
                        'Content-Type': 'application/json',
                        'X-CSRFToken': csrfToken
                    }
                }).then(async response => {
                if (!response.ok) {
                    const errorData = await response.json();
                    handlePlotError(errorData.error);
                    throw new Error(errorData.error);
                }
                const result = await response.json();
                dispatch(setPlotSignal(result));

            })
            .then(() => {
                
                fetchSignals();

                hookParts(tableContainerRef);
                
            }).catch(error => handlePlotError(error));
            
        } catch (err) {            
            console.error('Error plotting data:', err);
            handlePlotError('Oops! Something went wrong while trying to display the result');
        }        
    };

    const plot_Strategies = async (symbol, interval, s_Date, e_Date, dChanged) => {        
        try {

            await refreshTokenIfNeeded();
            
            if(strategyError !== null) return;

            dispatch(setBlinkWallet(false));

            if (checked && walletId===0) { 
                const errorMsg = "You’ll need to connect your wallet to use your strategies. Please connect to proceed."               
                setStrategyError(errorMsg);
                setTimeout(() => {
                    dispatch(setBlinkWallet(true));
                  }, 300);                
                throw new Error(errorMsg);
            }

            const sDate = formatDate(s_Date);
            const eDate = formatDate(addDays(e_Date, 1));

            dispatch(setBlinking(false)); 
            dispatch(setSpinStrategies(true));

            const wallet = checked ? walletId : 0;
                        
            const strFetch = `/api/plot_best_strategies?symbol=${symbol}&interval=${interval}&sDate=${sDate}&eDate=${eDate}&dateChanged=${dChanged}&walletId=${wallet}&follower=${walletId}`;
            
            const response = await fetch(strFetch, {
                method: 'GET',
                headers: {                    
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                }
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                handlePlotStrategiesError(errorData.error);
                throw new Error(errorData.error);
            }
    
            const result = await response.json();
            dispatch(setPlotStrategies(result));            
    
            // Handle date range change
            dispatch(setDateRangeChanged(false));            
    
            // Call fetchData and wait for it to finish            
            await fetchData();            
    
            // Once fetchData is done, perform the rest
            dispatch(setSpinStrategies(false));
            hookParts(plotStrategiesRef);            
            
        } catch (err) {
            dispatch(setSpinStrategies(false));
            console.error('Error plotting data:', err);
            setStrategyError(err);
        }        
    };  

    useEffect(() => {
        const matchingIndex = strategiesData.findIndex(
            item =>
                item.ema_1 === selectedStrategyPlot.ema_1 &&
                item.ema_2 === selectedStrategyPlot.ema_2 &&
                item.strategy === selectedStrategyPlot.strategy
        );
    
        if (matchingIndex !== -1) {
            dispatch(setSelectedRowIndex(matchingIndex));
    
            // Wait for the UI to update with the selected row
            setTimeout(() => {
                const table = document.querySelector(`.${styles.table}`);
                if (table) {
                    const row = table.querySelector(`.${styles.selectedRow}`);
                    if (row) {
                        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
            }, 100); // Adjust delay as necessary
        }
    }, [strategiesData, selectedStrategyPlot, dispatch]);    

    const handleDefaultStrategies = useCallback(() => {
        if (interval && Object.keys(selectedSymbol).length !== 0 && startDate !== '') {            
            dispatch(setBlinking(true));
            dispatch(setSelectedRowIndex(null));
            dispatch(setDateRangeChanged(false));
            dispatch(setPlotStrategies([]));
            dispatch(setStrategiesData([]));
            dispatch(setPlotSignal({}));
            dispatch(setSignalsData(null));
            setStrategyError(null);
            // dispatch(setSelectedStrategy(''));
            dispatch(setSelectedStrategy({'symbol' : '', 'interval' : '', 'ema_1':'', 'ema_2' : '', 'strategy' : ''}));
        }
    }, [dispatch, interval, selectedSymbol, startDate]);

    useEffect(()=>{
        if(walletId === previousWalletId) return;
        dispatch(setPreviousWalletId(walletId));
        handleDefaultStrategies();
        dispatch(setChecked(false));
    },[walletId, dispatch, handleDefaultStrategies, previousWalletId]);

    useEffect(() => {
        if (prices && selectedSymbol && signalsData) {
            // Ensure selectedSymbol is a string
            const symbolKey = String(selectedSymbol.value).replace('-', '') + 'T';
            const symbolPrice = prices[symbolKey] || 0; // Default to 0 if not found            
            setSnapshotPrice(symbolPrice.toFixed(7));
        }
    }, [prices, selectedSymbol, signalsData]); 
   

    const minDate = getMinDate(isPremium ? 725 : 90);
    const maxDate = addDays(new Date(), isPremium ? 0 : -30); // -30

    // Calculate the total profit percent, ensuring signalsData is not null
    const totalProfitPercent = (signalsData || []).reduce((sum, item) => {
        return Number(sum) + Number(item.profite_percent);
    }, 0);

    const totalPositiveGainProfitPercent = (signalsData || []).reduce((sum, item) => {
        const profite_percent = Number(item.profite_percent);
        const profite = profite_percent > 0 ? profite_percent : 0;
        return Number(sum) + Number(profite);
    }, 0);

    const totalNegativeGainProfitPercent = (signalsData || []).reduce((sum, item) => {
        const profite_percent = Number(item.profite_percent);
        const profite = profite_percent < 0 ? profite_percent : 0;
        return Number(sum) + Number(profite);
    }, 0);

    const isOperationOpen = (signalsData || []).reduce((sum, item) => {       
        return item.sell_price === 0;
    }, 0);
    
    const totalOfTransactions = (signalsData || []).reduce((sum, item) => {
        const profite_sell = Number(item.sell_price);
        const profite_buy = Number(item.buy_price);
        var profiteSell = 0;
        var profiteBuy = 0;
        profiteSell = profite_sell > 0 ? profiteSell + 1 : profiteSell;
        profiteBuy = profite_buy > 0 ? profiteBuy + 1 : profiteBuy;
        return Number(sum) + (profiteSell + profiteBuy);
    }, 0);
    
    const createSignalSymbol = (buySignalToday, sellSignalToday) => {
        // If buy_Signal_Today is true, return green up arrow
        if (buySignalToday === true) {
            return '▲';  // Green triangle up
        }
    
        // If sell_Signal_Today is true, return red down arrow
        if (sellSignalToday === true) {
            return '▼';  // Red triangle down
        }
    
        // If both are equal or neither is true, return empty
        return '';
    }

    
    const getFollowStatus = (followStatus, tooltip = false) => {

        let colorStatus = '#303030'
        let tooltipTxt = ''

        if(!checked && followStatus==='SF'){
            colorStatus = '#aefe43'
            tooltipTxt = 'You are following this system strategy'
        }
        else if(!checked && followStatus==='S'){
            colorStatus = '#3c5916'
            tooltipTxt = 'You are following this system strategy, but it is currently turned off'
        }
        else if(checked && followStatus==='CF'){
            colorStatus = '#0071ff'
            tooltipTxt = 'You are following this custom strategy'
        }
        else if(checked && followStatus==='C'){
            colorStatus = '#183860'
            tooltipTxt = 'You are following this custom strategy, but it is currently turned off'
        }

        const result = tooltip ? tooltipTxt : colorStatus

        return result
    };
 

    const getPieData = () => {
        let buyCount = 0;
        let sellCount = 0;
        let neutralCount = 0;
    
        strategiesData.forEach(item => {
            if (item.buy_Signal_Today === true) {
                buyCount++;
            } else if (item.sell_Signal_Today === true) {
                sellCount++;
            } else {
                neutralCount++;
            }
        });
    
        return [
            { name: 'Buy', value: buyCount },
            { name: 'Sell', value: sellCount },
            { name: 'Neutral', value: neutralCount }
        ];
    };

    function calculatePercentageAsync(price1, price2) {
        return (((price2 - price1) / price1) * 100).toFixed(2);
    }
    
    return (
        <><div className={`${styles.main_page} ${styles.scrollableContainer}`}>
            <header className={styles.main_header} style={{ backgroundColor: checked ? '#2a89b0' : '#9cb02a' }}>
                <h1>Trade Simulation</h1>
            </header>
            <main>
                <section className={styles.content}>
                    <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                        <Switch
                            onChange={handleCheckChange}
                            checked={checked}
                            offColor="#888"
                            onColor="#00c100"
                            offHandleColor="#fff"
                            onHandleColor="#fff" />
                        {!isPremium &&
                            <div style={{ position: 'absolute', right: '8%' }}>
                                <LimitedAdvise
                                    width="80px"
                                    height="20px"
                                    message="Limited"
                                    tooltipTitle="Why this page is limited?"
                                    tooltipPhrases={[
                                        "Up to 10 symbols",
                                        "Strategy simulation not available",
                                        "Strategy variations metrics not available",
                                        "Limited to 90 calendar days",
                                        "Last 30 days simulation not supported",
                                        "Notifications unavailable"
                                    ]}
                                    tooltipPosition="left" /* Options: top, down, left, right */
                                    tooltipWidth='320px' />
                            </div>}
                        <label style={{ padding: '10px' }}>
                            <span>{checked ? walletId === 0 ? <span style={{ color: 'orange' }}>Wallet not connected! Please connect your wallet to continue. If this is your first connection, you’ll receive a 1-day trial.</span> : 'You are using your Strategies' : "You are using system Strategies"}</span>
                        </label>
                    </div>
                    <p style={{ fontSize: '15pt' }}>
                    Welcome to the simulation page, ideal for long-term holders. This tool helps you analyze strategy behaviors using built-in indicators like RSI, Stochastic, EMA Crosses, and more. You can also create your own strategies to see how they would have performed based on the selected data range. We recommend using data from the last 6 months, as it aligns well with recent market trends, but feel free to explore further back to uncover insights from the market’s history.
                    </p><br />
                    <TextBaloon number="1" textColor={checked ? '#d2d2d2' : '#394b00'} text={<>To get started, first select one of the cryptocurrencies from the list, then choose an interval and finally the date range.</>} color={checked ? '#5358b7' : '#8bb753'} />
                    <br />
                    <div ref={entriesRef}>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <fieldset className={styles.fieldset}>
                                            <legend className={styles.legend}>Available Symbols</legend>
                                            <div className={styles.select_container}>                                           
                                                <CustomSelect handleChange={handleChange} selectedOption={selectedSymbol}/>
                                            </div>
                                        </fieldset>
                                    </td>
                                    <td>
                                        <fieldset className={styles.fieldset}>
                                            <legend className={styles.legend}>Select Interval</legend>
                                            <div className={`${styles.radio_container} ${interval === '4h' ? styles.selected : ''}`} onClick={() => handleIntervalChange('4h')}>
                                                4 hours Interval
                                            </div>
                                            <div className={`${styles.radio_container} ${interval === '1d' ? styles.selected : ''}`} onClick={() => handleIntervalChange('1d')}>
                                                1 day Interval
                                            </div>
                                        </fieldset>
                                    </td>
                                    <td>
                                        <fieldset className={styles.fieldset} style={{ height: '50px', textAlign: 'center' }}>
                                            <legend className={styles.legend}>Start Date ({startDate !== '' ? new Date(startDate).toDateString() : "No date selected"})</legend>
                                            <DataPicker minDate={minDate} maxDate={addDays(maxDate, -30)} onDateChange={handleStartDateChange} selectedDate={endDate !== '' ? new Date(startDate) : null} />
                                        </fieldset>

                                        <fieldset className={styles.fieldset} style={{ height: '50px', textAlign: 'center' }}>
                                            <legend className={styles.legend}>End Date ({endDate ? new Date(endDate).toDateString() : "No date selected"})</legend>
                                            <DataPicker disabled={startDate === ''} minDate={addDays(startDate, 30)} maxDate={maxDate} onDateChange={handleEndDateChange} selectedDate={endDate !== '' ? new Date(endDate) : null} />
                                        </fieldset>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button id="btnPlotStrategies" disabled={!(Object.keys(selectedSymbol).length !== 0 && interval !== '' && startDate !== '' && endDate !== '')} className={(Object.keys(selectedSymbol).length !== 0 && interval !== '' && startDate !== '' && endDate !== '' && blinking) ? (checked ? styles.blinking_user : styles.blinking_default) : ''} style={{ cursor:'pointer', width: '-webkit-fill-available', height: '80px', fontSize: "25px", backgroundColor: checked ? '#5358b7' : '#8bb753' }} onClick={() => handlePlotStrategies(selectedSymbol, interval, startDate, endDate, dateRangeChanged)}>Plot Strategies</button>
                        {/* <button id="btnPlotStrategies" disabled={!(Object.keys(selectedSymbol).length !== 0 && interval && startDate!=='' && endDate!=='')} className={ (Object.keys(selectedSymbol).length !== 0 && interval !== '' && startDate!=='' && endDate!=='') ? blinking && checked && walletId > 0 ? styles.blinking_user : blinking && !checked ? styles.blinking_default : '' : ''} style={{ width: '-webkit-fill-available', height: '80px', fontSize:"25px", backgroundColor: checked ? '#5358b7' : '#8bb753' }} onClick={() => handlePlotStrategies(selectedSymbol, interval, startDate, endDate, dateRangeChanged)}>Plot Strategies</button> */}


                        {spinStrategies &&
                            <><br /><br /><Spinner title="Creating Strategies..." color="#7572c7" /></>}
                        <br /><br />
                        {strategyError && <><div ref={plotStrategiesRef} className={styles.error}>{strategyError.message === '' ? strategyError : strategyError.message}</div><br /><br /></>}

                        {plotStrategies.length > 0 && (
                            <>
                                {!isPremium &&
                                    <BecomePremiumInvite />}
                                <br /><br />
                                <div ref={plotStrategiesRef}>
                                    <TextBaloon number="2" textColor={checked ? '#d2d2d2' : '#394b00'} text={<>The strategy chart below shows the best and worst results from the selected date range. The highlighted bar represents the most profitable strategy with the fewest operations, which is ideal for use in swappers apps with your wallet. Don’t overlook the other results, some strategies may be less profitable but could offer more consistent performance. You might be surprised by how some strategies perform over time. Click on one of the bars below or a row in step 3.<br />
                                    </>} color={checked ? '#5358b7' : '#8bb753'} />
                                    <ChartBar data={plotStrategies} />
                                </div>
                            </>
                        )}

                        {strategiesData.length > 0 && (
                            <>
                                <br /><br />
                                <TextBaloon number="3" textColor={checked ? '#d2d2d2' : '#394b00'} text={<>Unique strategies, each with predefined parameters that influence its performance.
                                    The signal results vary among these strategies.While some use EMA Crosses, the strategies are not limited to them.<br />
                                    Choose a strategy from the list below. Note that each strategy may have at least one variation. On the far left, you can see today’s buy and sell signals, or nothing if there are none available.</>} color={checked ? '#5358b7' : '#8bb753'} />
                                <br />
                                <div ref={selectedPlotStrategyRef} className={styles.tableContainer}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#8cb753', color: '#3a4b00', position:'relative', zIndex:1}}>
                                                <th>DSig</th>
                                                <th>Symbol</th>                                                
                                                <th>Interval</th>
                                                <th>Ema_1</th>
                                                <th>Ema_2</th>
                                                <th>Strategy</th>
                                                <th>Operations</th>
                                                <th>Following</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {strategiesData.map((item, index) => (
                                                <tr style={{cursor:'pointer'}} ref={(el) => (tableRefs.current[index] = el)} key={index} onClick={() => handleTableRowClick(item, index)} className={`${item.best_result === true && index !== selectedRowIndex ? styles.recomendedRow : ''} ${index === selectedRowIndex ? styles.selectedRow : ''}`}>                                                    
                                                    <td style={{width:'5%', color: item.buy_Signal_Today ? '#0afd04' : (item.sell_Signal_Today ? '#ff2bc5' : 'inherit') }}>
                                                        {createSignalSymbol(item.buy_Signal_Today, item.sell_Signal_Today)}
                                                    </td>
                                                    <td>{item.symbol}</td>
                                                    <td>{item.interval}</td>
                                                    <td>{item.ema_1}</td>
                                                    <td>{item.ema_2}</td>
                                                    <td>{item.strategy}</td>
                                                    <td>{item.operations}</td>
                                                    <td>
                                                        <Tooltip tooltipText={getFollowStatus(item.follow_status, true)}>
                                                            <i 
                                                            style={{fontSize: '15px', color: getFollowStatus(item.follow_status)}} 
                                                            className="bi bi-circle-fill"
                                                            ></i>
                                                        </Tooltip>
                                                    </td>                                                   
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                    {strategiesData.length > 0 && (
                        <PieChartBuySellStrategies data={getPieData()} symbolIcon={selectedSymbol.symbol_icon}/>
                    )}
                    <div>
                        {strategyTableRow && (
                            <>
                                <br />
                                {plotError && <><div ref={plotErrorContainerRef} className={styles.error}>{plotError.message}</div><br /><br /></>}
                            </>
                        )}

                        {Object.keys(plotSignal).length > 0 && (
                            <>
                                <br /><br />
                                <TextBaloon number="4" textColor={checked ? '#d2d2d2' : '#394b00'} text={<>The results vary depending on the chosen strategy.
                                    While some strategies may yield better results, finding the best one is challenging because their performance depends on market behavior.
                                </>} color={checked ? '#5358b7' : '#8bb753'} />
                                <div ref={tableContainerRef}>
                                    <h1 style={{ backgroundColor: checked ? '#2a89b0' : '#9cb02a' }} className={styles.main_header}>Plot Result Signals for {strategyTableRow.symbol}</h1>
                                    <ChartSignals
                                        data={plotSignal.mkt_values}
                                        ticker={strategyTableRow.symbol}
                                        date_b={plotSignal.buy_date}
                                        data_buy={plotSignal.buy_price}
                                        date_s={plotSignal.sell_date}
                                        data_sell={plotSignal.sell_price} />
                                </div>
                            </>
                        )}
                        {(signalsData || []).length > 0 && (
                            <>
                                {!isPremium &&
                                    <BecomePremiumInvite />}
                                <br /><br />
                                <TextBaloon number="5" textColor={checked ? '#d2d2d2' : '#394b00'} text={<>This dashboard provides a detailed explanation of the operation results, illustrating how your trades would perform based on the above signals. Note that losses are inevitable, as the system aims to minimize larger potential losses. You can also receive signal updates through notifications and manage them as needed.</>} color={checked ? '#5358b7' : '#8bb753'} />
                                <br /><br />
                                <div>
                                    <table className={styles.dashboard_table}>
                                        <thead>
                                            <tr>
                                                <th style={{ fontSize: '20pt' }} colSpan="3">
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                        <span> Simulation Result for {strategyTableRow.symbol} </span>
                                                        <span style={{ fontSize: '15pt', color: checked ? '#5458b7' : '#8cb753', paddingLeft: '8px' }}> - Strategy : <b>{selectedStrategy['strategy']} - ({selectedStrategy['interval']})</b></span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ fontSize: '15pt' }}>
                                                <td style={{ width: '200px' }}><b>{getOperationDays()}</b> Day(s)</td>
                                                <td>Transactions : <b>{totalOfTransactions}</b></td>
                                                <td>Status : <b>{isOperationOpen ? 'Open' : 'Close'}</b></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="3" className={styles.dashboard_chart_cell}>
                                                    <div className={styles.dashboard_chart_container}>
                                                        <span style={{ color: '#6ce36d' }}>Gain <br /> {totalPositiveGainProfitPercent.toFixed(2)}%</span>
                                                        <div className={styles.chart_container}>
                                                            <HalfDonutChart value={totalPositiveGainProfitPercent} max={totalPositiveGainProfitPercent + (totalNegativeGainProfitPercent * -1)} width={300} height={300} thickness={40} />
                                                            <img src={selectedSymbol.symbol_icon} className={styles.centered_image} alt='' style={{borderRadius: '50%',}} />
                                                        </div>
                                                        <span style={{ color: '#ff4d4b' }}>Loss <br /> {totalNegativeGainProfitPercent.toFixed(2)}%</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontSize: '20pt', backgroundColor: 'white', color: '#575757' }} colSpan="3">
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                            <span>{isOperationOpen ? 'So far, this ' : 'This '} operation generated a profit of </span>
                                                            <span style={{ fontSize: '30pt', color: totalProfitPercent > 0 ? 'green' : 'red', paddingLeft: '8px' }}>
                                                                <b>{totalProfitPercent.toFixed(2)}%</b>
                                                            </span>
                                                        </div>
                                                        <div className={`${styles.button_container_notify} ${styles.button_notify}`} onClick={handleShow}>
                                                            <i className="bi bi-bell" style={{ marginRight: '5px' }}></i>
                                                            Follow this Strategy
                                                        </div>
                                                        <div style={{fontSize:'12pt', color:followMesssage.color}}>{followMesssage.message}</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {showInvite &&
                                        <><br /><BecomePremiumInvite /></>
                                    }                                    
                                </div><div ref={tableContainerRef} className={styles.tableContainer}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#8cb753', color: '#3a4b00' }}>
                                                <th>Buy Date</th>
                                                <th>Buy Price</th>
                                                <th>Sell Date</th>
                                                <th>Sell Price</th>
                                                <th>Profite (%)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {signalsData.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={{color:'#0ef80b'}}>{item.buy_date}</td>
                                                    <td style={{color:'#0ef80b'}}>{item.buy_price.toFixed(7)}</td>
                                                    <td style={{color:item.sell_date !== '' ? '#ff2bc5' : '#8080807d'}}>{item.sell_date !== '' ? item.sell_date : getFormattedTodayDate()}</td>                                                    
                                                    <td style={{color:item.sell_price > 0 ? '#ff2bc5' : '#8080807d'}}>{item.sell_price > 0 ? item.sell_price.toFixed(7) : snapshotPrice}</td>                                                    
                                                    <td style={{ color: item.profite_percent !== '' ? (item.profite_percent > 0 ? '#72f272' : '#f29a9a') : isOperationOpen ? '#8080807d' : '' }}>{item.profite_percent !== '' ? item.profite_percent : calculatePercentageAsync(item.buy_price.toFixed(7), snapshotPrice) }</td>
                                                    
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                </section>
            </main>
        </div><DecisionModal
                show={modalShow}
                onHide={handleClose}
                onConfirm={handleNotify}
                title={`You are Following ${checked ? 'your' : "the system's"} Strategy ${selectedStrategy['strategy']}`}
                spin={spin}
                actionConcluded={actionStatus} /></>
    );
}

export default Simulator;